import constants from 'config/constants';

let apiKey;
let env;
if (constants.ENV === 'production') {
  env = 'LIVE';
  apiKey =
    'U1VULTM5MTQ4NDpCLXAxLTAtNWY2YmE2ODgtMC0zMDJkMDIxNDIxYjI5ZjBmMTc4YjA4NGUxODMzNWU5Mzg5YjM1ZDlmYzViOTRiOGEwMjE1MDA4YjcwNmZmNmEyMTEyMDBjYWU4NDQwNWNmNWNjOTgwZTQ4NGVjOTI1';
} else {
  env = 'TEST';
  apiKey =
    'T1QtNDM3NDEwOkItcWEyLTAtNWUxZjg1MDYtMC0zMDJkMDIxNDJhZjA4ZWIwODRjYjg2ZjJhOTY1Y2ZkZDdhNTJhZDFkZGNkNjIzYzYwMjE1MDA4YjM3ZDA4M2VlNzlmMmM2MWFjNmFjMWM4OWZjMjRlYTY2ODI0ZmIw';
}

export default {
  env,
  apiKey,
};
